import { render } from "./MdvVideoHeader.vue?vue&type=template&id=9e49d64c&scoped=true"
import script from "./MdvVideoHeader.vue?vue&type=script&lang=js"
export * from "./MdvVideoHeader.vue?vue&type=script&lang=js"

import "./MdvVideoHeader.vue?vue&type=style&index=0&id=9e49d64c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e49d64c"]])

export default __exports__